"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("ellipse", {
    strokeWidth: "2",
    strokeLinejoin: "round",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    id: "path3583",
    cx: "7.9813662",
    cy: "11.668264",
    rx: "6.7829366",
    ry: "6.8026161"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ellipse", {
    strokeWidth: "2",
    strokeLinejoin: "round",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    id: "path3583-5",
    cx: "16.091457",
    cy: "11.69252",
    rx: "6.7829366",
    ry: "6.8026161"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: "1",
    d: "m 6.1397441,5.7893981 3.532238,2.0393385",
    id: "path3615"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: "1",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    d: "M 2.5840862,6.4995534 9.6028763,10.691121",
    id: "path3615-3-5"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    strokeOpacity: "1",
    d: "m 2.3495516,9.013272 6.6032392,3.799611",
    id: "path3615-3-5-4-2"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    strokeOpacity: "1",
    d: "m 1.9138374,11.447198 8.6694016,4.988515",
    id: "path3615-3-5-4-2-0"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    strokeOpacity: "1",
    d: "m 2.1958543,13.873604 7.0187905,4.191568",
    id: "path3615-3-5-6"
  })]
}));